import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { addDays, format, getISOWeek, isSameDay, startOfWeek } from 'date-fns';
import { de, enUS } from 'date-fns/locale';

export const currentMonday = () => startOfWeek(new Date(), { weekStartsOn: 1 });

export const WeekNavigator = ({ monday, onChange }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'de' ? de : enUS;
  const sunday = addDays(monday, 6);
  const isCurrent = isSameDay(monday, currentMonday());
  const btn = 'w-9 h-9 flex items-center justify-center rounded-xl border border-zinc-200 bg-white text-zinc-600 hover:bg-zinc-50 transition-colors';
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="week-navigator">
      <button className={btn} onClick={() => onChange(addDays(monday, -7))} data-testid="week-prev-btn" aria-label="prev">
        <ChevronLeft className="w-4 h-4" />
      </button>
      <div className="px-3 py-1.5 rounded-xl bg-white border border-zinc-200 text-sm" data-testid="week-label">
        <span className="font-bold text-zinc-900">{t('reports.calendarWeek')} {getISOWeek(monday)}</span>
        <span className="text-zinc-500"> · {format(monday, 'd. MMM', { locale })} – {format(sunday, 'd. MMM yyyy', { locale })}</span>
      </div>
      <button className={btn} onClick={() => onChange(addDays(monday, 7))} data-testid="week-next-btn" aria-label="next">
        <ChevronRight className="w-4 h-4" />
      </button>
      {!isCurrent && (
        <button onClick={() => onChange(currentMonday())} data-testid="week-today-btn" className="text-sm font-semibold text-[#D93025] hover:underline px-1">
          {t('reports.thisWeek')}
        </button>
      )}
    </div>
  );
};

export default WeekNavigator;
